import Vue from "vue";
import Vuex, { mapGetters } from "vuex";
import VueXAlong from "vuex-along";
import EventBus from "@/ws/eventBus";
import { addHeaderDriaverData } from "@/api/chatBox";
Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    VueXAlong({
      name: "along", //存放在localStroage或者sessionStroage 中的名字
      session: false, //是否存放在local中  false 不存放 如果存放按照下面session的配置配
      local: { list: [], isFilter: true },
      justSession: true,
    }),
  ],
  state() {
    return {
      // 就是公共的数据，所有的组件都可以直接使用
      organization: "",
      store: "",
      token: "", //用来调用司机地图
      //dispatch 数据
      newTask: [],
      read_msg: "",
      header_driver: [],
      click_driver: "",

      dis_unassigned_list:[],
      dis_map_point_data:{
        map_driver_list: []
      },
      dis_team_list:[],
      store_index:'',
      dirver_index:'',
      task_index:'',
      unassigned_index:'',
      task_draw_line_arr:[],
      setMes:{},
      set_store_data:[],
      set_map_driver:[],
      taskHash : {}, // 哈希表存储任务数据
      globalDialogTag:false,//全屏显示的遮罩dialog
      delyTaskData:{count:0},//yanchi renwu
      wage_scoll_num:'',//wage页面监听
    };
  },
  mutations: {
    //存储滚动事件
    sageWageScorll(state,a){
      state.wage_scoll_num = a
    },
    changeGlobalDialogStatus(state, a) {
      state.globalDialogTag = a;
    },
    updateDelayTask(state,a){
      state.delyTaskData = a

      let team_arr_changes = a.data
      // console.log('team_arr_changes=',team_arr_changes,state.dis_team_list)
      team_arr_changes.forEach(v=>{
        // console.log('vvv',v)
        for (let i = 0; i < state.dis_team_list.length; i++) {
          const item = state.dis_team_list[i];
          for (let j = 0; j < item.childen_data.length; j++) {
            const childen_data = item.childen_data[j];
            if(childen_data.childen_data.length >  0 ){
              for (let k = 0; k < childen_data.childen_data.length; k++) {
                const fenpeiTask = childen_data.childen_data[k];
                // console.log('任务，，，',fenpeiTask.task_id)
                let task_index_cahnge = state.dis_team_list[i].childen_data[j].childen_data.findIndex(t=>t.task_id == v)
                // console.log('task_index_cahnge,,,',task_index_cahnge)
                if(task_index_cahnge>-1){
                  state.dis_team_list[i].childen_data[j].childen_data[task_index_cahnge].delayStatus = 1

                }
              }
            }

          }
        }
      })

      state.dis_team_list = [...state.dis_team_list]
    },

    changeOrgination(state, a) {
      state.organization = a;
    },
    changeStore(state, a) {
      state.store = a;
    },
    changeToken(state, a) {
      state.token = a;
    },
    //存储头部司机
    updataHeaderDriver(state, a) {
      state.header_driver = a;
    },
    //存储被点击的司机
    saveDriverId(state, a) {
      state.click_driver = a;
      state.click_driver.fixed_index = a.fixed_index;
    },
    chagneDriverId(state) {
      state.click_driver.fixed_index = -1;
    },
    //接收消息 司机完成了一个任务 针对司机地图消息
    driverFinishTaskAtMap(state,msg){
      EventBus.$emit('onBindDriverMap',msg)
    },
    //接收聊天消息
    newMess(state, a) {
      // console.log("--ws-新消息处理--", a,state);
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      // console.log('--loginuserinfo--',userInfo)
      if (a.sender_id != userInfo.aid) {
        //判断 推送的消息 判断当前 header_driver 是否有发送过来的发送者id
        let result = state.header_driver.some((ele) => ele.id == a.sender_id); //true
        let arr = state.header_driver;
        let obj = {};
        if (result) {
          arr.forEach((v, index) => {
            if (v.id == a.sender_id) {
              v.is_point = 1
              obj = v;
              arr.splice(index, 1);
              return;
            }
          });
          arr.unshift(obj);

          let fixed_index = state.click_driver.fixed_index;
          let obj2 = state.click_driver;
          //需要判断fixed_index 不为 -1, 如果不为 -1则当前有打开的弹框 没点开窗口的情况下获取的值为undefined 2023年8月29日
          if (fixed_index != -1 && fixed_index!=undefined) {
            arr.forEach((v, i) => {
              if (v.id == obj2.id) {
                arr.splice(i, 1);
              }
            });
            arr.splice(fixed_index, 0, obj2);
          }
        } else {
          addHeaderDriaverData({
            id: a.sender_id,
          }).then((res) => {
            if (res.code == 200) {
              let obj = {
                id: a.sender_id,
                type: a.sender_type,
                firstName: a.receiver_name.charAt(0).toUpperCase() + a.receiver_name.charAt(1).toUpperCase(),
                is_point: 1,
                name: a.receiver_name
              }
              let objaaa = Object.assign(a,obj)
              // console.log('---xinduixiang--',objaaa)
              state.header_driver.unshift(objaaa);
              let arr = state.header_driver;
              // arr.forEach((v, index) => {
              //   if (v.id == a.sender_id) {
              //     v.is_point = 1
              //     obj = v;
              //     arr.splice(index, 1);
              //     return;
              //   }
              // });
              // arr.unshift(obj);

              let fixed_index = state.click_driver.fixed_index;
              let obj2 = state.click_driver;

              //需要判断fixed_index 不为 -1, 如果不为 -1则当前有打开的弹框
              if (fixed_index != -1 && fixed_index!=undefined) {
                arr.forEach((v, i) => {
                  if (v.id == obj2.id) {
                    arr.splice(i, 1);
                  }
                });
                arr.splice(fixed_index, 0, obj2);
              } else {
              }


            }
          });
        }
        EventBus.$emit("updateChatData", a);
        EventBus.$emit("updateRemindRing");
      }else{
        EventBus.$emit("updateChatDataAdmin", a);
      }
    },
    //重置地图画线
    restartDrawLine(state){
      state.task_draw_line_arr = []
    },
    //修改组织
    teamHandle(state, e) {
      const settings = JSON.parse(localStorage.getItem('set_select'));
      const store = settings.team_setting;
      const task = settings.task_setting;
      const obj = state.dis_map_point_data;
      const storeSet = new Set(store);
      const taskSet = new Set(task);
      let all_show_map = []
      all_show_map = obj?.map_task_list
      all_show_map?.forEach((tasks, index) => {
        tasks.show_map_tesk = false;
        tasks.open = false
        tasks.open_index = false
        let parent_store_arr = [];
        if (typeof tasks.parent_store === 'string') {
          parent_store_arr = tasks.parent_store.split('#').filter(p => p !== '' && p !== 'undefined').map(Number);
        } else if (Array.isArray(tasks.parent_store)) {
          parent_store_arr = tasks.parent_store;
        }
        const store_flage = parent_store_arr.some(item => storeSet.has(item));
        if (store_flage) {
          const status_x = tasks.status === 3 && tasks.success === 1 ? 3 : tasks.status === 3 && tasks.success === 0 ? 4 : tasks.status;
          tasks.show_map_tesk = taskSet.has(status_x);
        } else {
          if (tasks.status === 0) {
            tasks.show_map_tesk = taskSet.has(0);
          }
        }
      });

      obj?.map_driver_list?.forEach(driver => {
        driver.show_map = storeSet.has(driver.parent_driver);
      });

      state.dis_team_list.forEach(item => {
        item.show_tree = storeSet.has(item.id);
        if (!storeSet.size) {
          item.show_tree = false;
        }
        if (e !== 'addtree' && !storeSet.has(item.id)) {
          item.isExpand = false;
        }
      });
    },
//修改司机再地图上的展示
    changeMapDriver(state,e){
      state.dis_map_point_data?.map_driver_list?.forEach(driver=>{
        if (driver.is_online == 1 && driver.is_transfer == 0){
          driver.map_status = 1
        }else if (driver.is_online == 1 && driver.is_transfer == 1){
          driver.map_status = 2
        }
        let store = JSON.parse(localStorage.getItem('set_select')).team_setting
        let flage = e.findIndex(v=>v== driver.map_status)
        let store_flage = store.findIndex(a=>a == driver.parent_driver)
        if (flage>-1){
          if (store_flage > -1){
            driver.show_map = true
          }else {
            driver.show_map = false
          }
        }else {
          driver.show_map = false
        }
      })
    },
    //存储底部设置
    setBtomSetting(state,a){
      state.setMes = a
    },
    //存储地图上任务的点
    saveAllMapData(state,a){
      let obj = {
        map_hub_list:[],
        map_task_list:[],
        map_driver_list:[],
        complete_tasl_list:[],
      }
      obj.map_hub_list = a.hub_list
      let chongfuTask=[]
      a.team_list.forEach(store=>{
        store.task_list.forEach(tem=>{
          tem.task_type = 'temp'
          tem.parent_store = [store.id]
          obj.map_task_list.push(tem)
        })
        store.childen_data.forEach(driver=>{
          driver.parent_driver = store.id
          let finde_driver = obj.map_driver_list.findIndex(v=>v.worker_id == driver.worker_id)
          if (finde_driver == -1){
            let userData = JSON.parse(JSON.stringify(driver))
            delete userData.childen_data
            obj.map_driver_list.push(userData)
            driver.childen_data.forEach(task=>{
              task.parent_driver = driver.worker_id
              task.parent_store = store.id
              // 将任务分成两个数组 1个用来存放complete/fail 一个用来
              obj.map_task_list.push(task)
              //针对一个任务属于多个店铺的情况做处理
              let confuTaskObj = {
                taskId : task.task_id,
                parent_store:store.id
              }
              chongfuTask.push(confuTaskObj)

              if(chongfuTask.length>0){
                chongfuTask.forEach((item)=>{
                  if(item.taskId == task.task_id){
                    task.parent_store +=`#${item.parent_store}#`
                  }
                })
              }
            })
          }else {
          }
        })
      })
      obj.map_task_list.push.apply(obj.map_task_list, a.unassigned_task_list.data)
      obj.map_hub_list.forEach((v)=>{
        v.position={
          lat:Number(v.latitude),
          lng:Number(v.longitude)
        }
      })
      obj.map_task_list.forEach((v,i)=>{
        v.position={
          lat:Number(v.latitude),
          lng:Number(v.longitude)
        }
        state.taskHash[v.task_id] = v;
        v.open_index = false
        v.index = null
        v.open = false
        v.show_map_tesk = false
        v.mean = 'normal'
      })
      obj.map_driver_list.forEach((v)=>{
        v.position={
          lat:Number(v.latitude),
          lng:Number(v.longitude)
        }
        v.open = false
      })

      state.dis_map_point_data = obj
      // store.commit('teamHandle')
      store.commit('changeMapDriver',state.set_map_driver)
    },
    //司机点位变化时，修改司机的点, 同时需要考虑到连线
    changeDriverPoint(state,a){
      // 司机地图页面也需要实时更新位置
      EventBus.$emit('driverMapChangeDriver',a)
      state.dis_map_point_data.map_driver_list = state.dis_map_point_data.map_driver_list?.map(v=>{
        if (v.show_map){
          if (a.worker_id == v.worker_id){
            v.position = {
              lat:Number(a.latitude),
              lng:Number(a.longitude)
            }
          }
        }
        return v
      })
      // console.log(state.dis_map_point_data.map_driver_list,'更新司机位置')
      if (state.task_draw_line_arr.length > 0){
        if  (a.worker_id == state.task_draw_line_arr[0].id){
          state.task_draw_line_arr.splice(0,1)
          state.task_draw_line_arr.unshift({
            type:'driver',
            id:a.worker_id,
            lat:Number(a.latitude),
            lng:Number(a.longitude)
          })
        }
      }
    },
    //存储tree 原始数据
    saveTeamList(state,a){
      state.dis_team_list = a
      for (let i = 0; i < state.dis_team_list.length; i++) {
        let item = state.dis_team_list[i]
        item.isExpand = this.isExpand
        item.show_tree = false
        item.choose_task = false
        for (let j = 0; j < item.childen_data.length; j++) {
          let item2 = item.childen_data[j]
          item2.isExpand = this.isExpand
          if(item2.is_online == 1){
            state.dis_team_list[i].childen_data.unshift(state.dis_team_list[i].childen_data.splice(j , 1)[0]);
          }
        }
      }
      store.commit('teamHandle',state.set_store_data)
    },
    //存储 未分配列表原始数据
    saveUnassignedList(state,a){
      state.dis_unassigned_list = a
    },
    //点击司机节点时，地图上连线
    changeTaskLineArr(state,arr){
      // if (arr[0].type == 'driver'){
      state.task_draw_line_arr = []
      let newLineArr = []
      arr.forEach(v=>{
        newLineArr.push({
          id:v.worker_id,
          type:v.type?v.type:'',
          lat:Number(v.latitude),
          lng:Number(v.longitude)
        })
      })
      // }
      state.task_draw_line_arr = [...newLineArr]
    },
    //针对ws 接收到的任务做操作

    //根据判断推送消息的类型  task为推送任务消息  worker为司机消息 msg为消息通知
    // forward为taks的时候 forward_type类型根据forward_type判断推送任务内容
    // 0: 任务刚刚创建(未指派)
    // 1: 任务编辑(只是修改任务内容)
    // 2: 任务删除(删除任务)
    // 3. 任务指派给某个司机(已经指派任务了)
    // 4: 任务司机点击取货后任务更新
    // 5: 司机点star任务后任务更新
    // 6: 司机点完成后任务更新
    // 7:取消任务指派
    changeTaskHandle(state,message){
      let data =message
      switch(data.forward_type) {
        case 0:
          message.add_new = 0
          store.commit('addUnassignedLists',message)
          break;
        case 1:
          store.commit('editTasksStatus',message)
          break;
        case 2:
          if (data.status != 0){
            let obj2 = {
              task:data,
            }
            store.commit('deleteTreeDriverTask',obj2)
          }else if (data.status == 0){
            message.delete_type = 2
            store.commit('deleteUnassignedList',message)
          }
          break;
        case 3:
          if (data.status != 0){
            let obj = {
              index2:0,
              droTask:data
            }
            if  (message.worker_id!="" && message.team_id != ''){
              store.commit('assignedTreeTask',obj)
            }else {
              let store_id = JSON.parse(data.team_id)
              // console.log('store_id,',store_id)
              let store_index = state.dis_team_list.findIndex(v=>v.id == store_id[0])
              // console.log('store_index,',store_index)
              if (store_index > -1){
                state.dis_team_list[store_index].task_list.unshift(message)
              }
            }
            store.commit('deleteUnassignedList',message)
          }else if (data.status == 0){
            if  (message.team_id == '' || message.worker_id == ''){
              message.add_new = 1
              store.commit('addUnassignedLists',message)
              state.dis_team_list.forEach(v=>{
                let temp_index = v.task_list.findIndex(a=>a.task_id == message.task_id)
                if (temp_index>-1){
                  v.task_list.splice(temp_index,1)
                }
              })
            }else {
              let objs= {
                index:state.store_index,
                index2:-1,
                droTask:data
              }
              store.commit('assignedTreeTask',objs)
            }
          }
          break;
        case 4:
          store.commit('pickTasksStatus',message)
          break;
        case 5:
          store.commit('completeTasksStatus',message)
          break;
        case 6:
          store.commit('completeTasksStatus',message)
          break;
      }
      if (message.forward_type == 7){
        let obj7 = {
          task:message
        }
        store.commit('deleteTreeDriverTask',obj7)
      }
    },
    //通过店铺id 返回店铺index

    //新增unassigned
    addUnassignedLists(state,a){
      if  (a.add_new == 0){
        EventBus.$emit('newTaskCome', a)
      }
      state.dis_unassigned_list.data.unshift(a)
      //使用查询哈希表的方式查询数据
      const search_task = state.taskHash[a.task_id]
      if (search_task){
        search_task.status = a.status
        search_task.show_map_tesk = searchTaskStatusSet(a)
        let MapTaskStatus = state.dis_map_point_data.map_task_list.findIndex(v=>v.task_id == search_task.task_id)
        state.dis_map_point_data.map_task_list[MapTaskStatus].status = a.status
      }else {
        a.open_index = false
        a.index = null
        a.open = false
        a.mean = 'normal'
        a.position={
          lat:Number(a.latitude),
          lng:Number(a.longitude)
        }
        a.show_map_tesk = searchTaskStatusSet(a)
        state.dis_map_point_data.map_task_list.push(a)
      }
      if (state.task_draw_line_arr.length>0){
        const delete_map = state.task_draw_line_arr.findIndex((data) => {
          return (
            Number(a.latitude)  === data.lat && Number(a.longitude)  === data.lng
          );
        });
        if  (delete_map){
          state.task_draw_line_arr.splice(delete_map,1)
        }
      }
    },
    //删除unassigned
    deleteUnassignedList(state,a){
      //未分配任务删除 包含两种情况1.删除任务 2.修改任务状态 unassigned>assigend
      let index=state.dis_unassigned_list.data.findIndex((value)=>value.task_id==a.task_id);
      if (index>-1){
        state.dis_unassigned_list.data.splice(index,1)
        if (a.delete_type == 2){
          let delete_index = state.dis_map_point_data.map_task_list.findIndex(v=>v.task_id == a.task_id)
          state.dis_map_point_data.map_task_list.splice(delete_index,1)
        }
      }else {
        if (a.worker_id !=''){
          state.dis_team_list.forEach(v=>{
            let temp_index = v.task_list.findIndex(b=>b.task_id == a.task_id)
            if (temp_index>-1){
              v.task_list.splice(temp_index,1)
            }
          })
        }else {
          state.dis_team_list.forEach(v=>{
            let team_id = JSON.parse(a.team_id)
            let inner_team = team_id.findIndex(b=>b==v.id)
            if (inner_team == -1){
              let temp_index = v.task_list.findIndex(c=>c.task_id == a.task_id)
              if (temp_index>-1){
                v.task_list.splice(temp_index,1)
              }
            }
          })
        }
      }

    },
    //新增树
    assignedTreeTask(state,e){
      let search_task = state.taskHash[e.droTask.task_id]
      if (!search_task){
        e.droTask.position={
          lat:Number(e.droTask.latitude),
          lng:Number(e.droTask.longitude)
        }
        e.droTask.open_index = false
        e.droTask.index = null
        e.droTask.open = false
        e.droTask.show_map_tesk = false
        e.droTask.mean = 'normal'
        state.taskHash[e.droTask.task_id] = e.droTask;
        search_task = state.taskHash[e.droTask.task_id]
      }
      let MapTaskStatus = state.dis_map_point_data.map_task_list.findIndex(v=>v.task_id == search_task.task_id)
      state.dis_map_point_data.map_task_list[MapTaskStatus].status = e.droTask.status
      if (e.index2 == 0 || e.index2 >0){
        let team_arr_change = JSON.parse(e.droTask.team_id)
        team_arr_change.forEach(v=>{
          let store_index_change = state.dis_team_list.findIndex(a=>a.id == v)
          if (store_index_change > -1){
            let driver_index_change = state.dis_team_list[store_index_change].childen_data.findIndex(b=>b.worker_id==e.droTask.worker_id)
            if (driver_index_change > -1){
              e.droTask.parent_store = team_arr_change
              e.droTask.parent_driver = e.droTask.worker_id
              state.dis_team_list[store_index_change].childen_data[driver_index_change].childen_data.splice(e.index3, 0, e.droTask)
              state.dis_team_list[store_index_change].childen_data[driver_index_change].title_total_count++
            }
          }
        })
        if (e.droTask.sort_list){
          let sort = JSON.parse(e.droTask.sort_list)
          let obj = {
            sort:sort,
            worker_id:e.droTask.worker_id
          }
          store.commit('sortTreeList',obj)
        }
        if (search_task){
          search_task.parent_store = team_arr_change
          search_task.parent_driver =e.droTask.worker_id
          search_task.status = e.droTask.status
        }
      }else {
        //分配给临时店铺了
        state.dis_team_list[e.index].task_list.push(e.droTask)
      }

      search_task.show_map_tesk = searchTaskStatusSet(e.droTask)
    },
    //司机中删除任务
    deleteTreeDriverTask(state,e){
      let team_arr_change = JSON.parse(e.task.team_id)
      team_arr_change.forEach(v=>{
        let store_index_change = state.dis_team_list.findIndex(a=>a.id == v)
        if (store_index_change > -1){
          let driver_index_change = state.dis_team_list[store_index_change].childen_data.findIndex(b=>b.worker_id==e.task.worker_id)
          if (driver_index_change > -1){
            let true_task = ''
            if (e.task.forward_type == 7){
              true_task= state.dis_team_list[store_index_change].childen_data[driver_index_change].childen_data.findIndex(c=>c.task_id == e.task.task[0])
            }else {
              true_task= state.dis_team_list[store_index_change].childen_data[driver_index_change].childen_data.findIndex(c=>c.task_id == e.task.task_id)
            }
            if (true_task >-1){
              state.dis_team_list[store_index_change].childen_data[driver_index_change].childen_data.splice(true_task, 1)
            }
            state.dis_team_list[store_index_change].childen_data[driver_index_change].title_total_count >0 ?--state.dis_team_list[store_index_change].childen_data[driver_index_change].title_total_count:0
          }else {
            //worker_id 找不到的情况，可能是分组任务，可以查询分组中是否有这个任务 然后删除
            let team_task = state.dis_team_list[store_index_change].task_list.findIndex(v=>v.task_id == e.task.task_id)
            if (team_task>-1){
              state.dis_team_list[store_index_change].task_list.splice(team_task,1)
            }
          }
        }
      })
      if  (e.task.forward_type == 2){
        let delete_index = state.dis_map_point_data.map_task_list.findIndex(v=>v.task_id == e.task.task_id)
        state.dis_map_point_data.map_task_list.splice(delete_index,1)
        //将该任务的点删掉，不再连线 2023年8月3日

        const delete_map = state.task_draw_line_arr.findIndex((data) => {
          return (
            Number(e.task.latitude)  === data.lat && Number(e.task.longitude)  === data.lng
          );
        });
        if  (delete_map >-1){
          state.task_draw_line_arr.splice(delete_map,1)
        }
      }
    },
    //重新排序
    sortTreeList(state,e){
      let worker_id = e.worker_id
      let arr = e.sort
      if (arr == 'null') return
      let sort_list = []
      state.dis_team_list.forEach((store,store_index)=>{
        let index = store.childen_data.findIndex(v=>v.worker_id == worker_id)
        if (index > -1){
          arr.forEach(a=>{
            state.dis_team_list[store_index].childen_data[index].childen_data.forEach(b=>{
              if (a[0]== b.task_id){
                let current_index = sort_list.findIndex(v=>v.task_id == b.task_id)
                if (current_index == -1){
                  sort_list.push(b)
                }
              }
            })
          })
          state.dis_team_list[store_index].childen_data[index].childen_data = sort_list
          if (state.task_draw_line_arr.length>0){
            //这里判断一下 被分配的任务 是不是当前司机的
            console.log(worker_id,state.task_draw_line_arr)
            if(worker_id == state.task_draw_line_arr[0].id){
              let line_arr = sort_list.filter(item=>item.status ==1 || item.status == 2)
              let driver = state.dis_team_list[store_index].childen_data[index]
              // console.log(driver,'看看司机')
              if (driver.is_online == 1){
                line_arr.unshift({
                  type:'driver',
                  latitude:driver.latitude,
                  longitude:driver.longitude,
                  name:driver.name,
                  worker_id:driver.worker_id,
                })
              }
              // this.changeTaskLineArr(line_arr)
              this.commit('changeTaskLineArr',line_arr)
            }
          }
        }
      })
    },
    //修改司机状态
    updateDriverStatus(state,e){
      let arr = JSON.parse(e.group_id)
      arr.forEach(groud=>{
        let store_index = state.dis_team_list.findIndex(store=>store.id == groud)
        if (store_index>-1){
          // e.is_online == 1?state.dis_team_list[store_index].duty++:state.dis_team_list[store_index].duty--
          let driver_index = state.dis_team_list[store_index].childen_data.findIndex(driver=>driver.worker_id == e.worker_id)
          state.dis_team_list[store_index].childen_data[driver_index].is_online = e.is_online
          state.dis_team_list[store_index].childen_data[driver_index].show_map = true
          state.dis_team_list[store_index].childen_data[driver_index].is_transfer = e.is_transfer
          state.dis_team_list[store_index].childen_data.map((item,index) => {
            let driver_index = state.dis_map_point_data.map_driver_list.findIndex(v=>v.worker_id == e.worker_id)
            if (driver_index >-1){
              if (e.is_online == 1){
                state.dis_map_point_data.map_driver_list[driver_index].is_online = e.is_online
                state.dis_map_point_data.map_driver_list[driver_index].is_transfer = e.is_transfer
              }else {
                state.dis_map_point_data.map_driver_list.splice(driver_index,1)
              }
            }else {
              e.position = {
                lat:Number(e.latitude),
                lng:Number(e.longitude)
              }
              e.show_map = true
              e.open = false
              state.dis_map_point_data.map_driver_list.push(e)
              state.dis_map_point_data.map_driver_list =[...state.dis_map_point_data.map_driver_list]
            }
            //将上线的司机置顶
            let indexs = state.dis_team_list[store_index].childen_data.findIndex(v=>v.worker_id == e.worker_id)
            if (e.is_online == 1){
              state.dis_team_list[store_index].childen_data.unshift(state.dis_team_list[store_index].childen_data.splice(indexs , 1)[0]);
            }else {
              state.dis_team_list[store_index].childen_data.push(state.dis_team_list[store_index].childen_data.splice(indexs , 1)[0]);
            }
            let duty_length = state.dis_team_list[store_index].childen_data.filter(v=>v.is_online == 1)
            state.dis_team_list[store_index].duty = duty_length.length
          })
        }
      })
    },
    //修改任务状态
    completeTasksStatus(state,e){
      let team_arr_changes = JSON.parse(e.team_id)
      team_arr_changes.forEach(v=>{
        let store_index_change = state.dis_team_list.findIndex(a=>a.id == v)
        if (store_index_change > -1){
          let driver_index_change = state.dis_team_list[store_index_change].childen_data.findIndex(b=>b.worker_id==e.worker_id)
          if (driver_index_change > -1){
            if (e.forward_type == 6){
              state.dis_team_list[store_index_change].childen_data[driver_index_change].title_count++
            }
            let task_index_cahnge = state.dis_team_list[store_index_change].childen_data[driver_index_change].childen_data.findIndex(t=>t.task_id == e.task_id)
            if  (task_index_cahnge>-1){
              state.dis_team_list[store_index_change].childen_data[driver_index_change].childen_data[task_index_cahnge].status = e.status
            }
          }
        }
      })
      if (e.forward_type == 6){
        //任务完成之后将该任务的点删掉，不再连线 2023年8月3日
        //如果当前worker_id == 连线数组里面的worker_id
        const delete_map = state.task_draw_line_arr.findIndex((data) => {
          return (
            Number(e.latitude)  === data.lat && Number(e.longitude)  === data.lng
          );
        });
        if  (delete_map>-1){
          state.task_draw_line_arr.splice(delete_map,1)
        }
      }
      const search_task = state.taskHash[e.task_id]
      e.status = e.status === 3 ? e.success === 1 ? 3 : 4 : e.status;
      search_task.status = e.status
      search_task.success = e.success// 将任务的成功失败状态也同步修改 2023年8月6日
      let MapTaskStatus = state.dis_map_point_data.map_task_list.findIndex(v=>v.task_id == search_task.task_id)
      state.dis_map_point_data.map_task_list[MapTaskStatus].status = e.status
      state.dis_map_point_data.map_task_list[MapTaskStatus].show_map_tesk = searchTaskStatusSet(e)
    },

  }
});
function searchTaskStatusSet(a){
  let task = JSON.parse(localStorage.getItem('set_select')).task_setting
  let flage = task.findIndex(v=>v == a.status)
  if (flage>-1){
    return true
    // search_task.show_map_tesk = true
  }else {
    return false
    // search_task.show_map_tesk = false
  }
}
export default store;
